export default {
  dark: {
    "oxygen-devices-disclaimer-text": "neutral-200",
    "secondary-contact-type": "neutral-100",
    "secondary-container": "neutral-300",
    "service-animal-disclaimer-text": "neutral-200",
  },
  light: {
    "oxygen-devices-disclaimer-text": "neutral-200",
    "secondary-contact-type": "neutral-100",
    "secondary-container": "neutral-300",
    "service-animal-disclaimer-text": "neutral-200",
  },
};
